"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslateService = void 0;
const da_json_1 = __importDefault(require("./i18n/da.json"));
const de_json_1 = __importDefault(require("./i18n/de.json"));
const du_json_1 = __importDefault(require("./i18n/du.json"));
const en_json_1 = __importDefault(require("./i18n/en.json"));
const en_gb_json_1 = __importDefault(require("./i18n/en-gb.json"));
const es_json_1 = __importDefault(require("./i18n/es.json"));
const fr_json_1 = __importDefault(require("./i18n/fr.json"));
const nn_json_1 = __importDefault(require("./i18n/nn.json"));
const pt_json_1 = __importDefault(require("./i18n/pt.json"));
const sv_json_1 = __importDefault(require("./i18n/sv.json"));
class TranslateService {
    constructor() {
        this.lang = "en";
        this.units = "metric";
        this.allTranslations = {};
        this.tokens = {};
        this.allTranslations["da"] = da_json_1.default;
        this.allTranslations["du"] = du_json_1.default;
        this.allTranslations["de"] = de_json_1.default;
        this.allTranslations["en"] = en_json_1.default;
        this.allTranslations["en-gb"] = en_gb_json_1.default;
        this.allTranslations["es"] = es_json_1.default;
        this.allTranslations["fr"] = fr_json_1.default;
        this.allTranslations["nn"] = nn_json_1.default;
        this.allTranslations["pt"] = pt_json_1.default;
        this.allTranslations["sv"] = sv_json_1.default;
    }
    setUnits(units) {
        this.units = units;
    }
    setLang(lang) {
        this.lang = lang;
        this.translations = this.allTranslations[lang];
    }
    setToken(key, value) {
        this.tokens[key] = value;
    }
    get(key) {
        let translation = "";
        if (key.indexOf(".") > -1) {
            const keys = key.split(".");
            translation = this.translations[keys[0]];
            for (let i = 1; i < keys.length; i++) {
                translation = translation[keys[i]];
            }
        }
        else {
            translation = this.translations[key] || "";
            if (this.units === "us" && this.translations[`${key}_US`]) {
                translation = this.translations[`${key}_US`];
            }
        }
        if (!translation) {
            console.warn("Missing translation for", key);
        }
        if (typeof translation === "string") {
            translation = this.replaceTokens(translation);
        }
        return translation;
    }
    replaceTokens(val) {
        return val.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, token) => {
            return this.tokens[token] || match;
        });
    }
}
exports.TranslateService = TranslateService;
